"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M19 9h-1V6c0-1.1-.9-2-2-2h-6c-1.1 0-2 .9-2 2v14h12c1.1 0 2-.9 2-2v-6c0-1.66-1.34-3-3-3m-9-3h6v3h-6zm4 11h-4v-5h4zm2 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m0-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m3 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m0-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1M4.5 8C3.12 8 2 9.12 2 10.5v8C2 19.88 3.12 21 4.5 21S7 19.88 7 18.5v-8C7 9.12 5.88 8 4.5 8"
}), 'FaxRounded');